export const heroData = {
  title: '发现精彩，创造无限',
  subtitle: '蜜桃传媒汇聚海量精品内容，连接创作者与观众，打造中国领先的优质内容生态平台',
  ctaPrimary: '立即探索',
  ctaSecondary: '成为创作者',
  stats: [
    { value: '500万+', label: '月活用户' },
    { value: '10万+', label: '优质创作者' },
    { value: '100万+', label: '精品内容' },
    { value: '98%', label: '用户满意度' },
  ],
};

export const featuredContent = [
  {
    id: 1,
    title: '2026年最值得期待的电影大盘点',
    excerpt: '从国产巨制到国际大片，带你一览今年不可错过的电影盛宴，每一部都值得走进影院。',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20collage%20with%20warm%20theater%20lighting%2C%20film%20reel%20elements%2C%20elegant%20composition%2C%20dark%20background%20with%20golden%20highlights%2C%20editorial%20design%20style%2C%20soft%20gradients&width=800&height=500&seq=featured-01&orientation=landscape',
    category: '影视娱乐',
    author: '影评人小王',
    date: '2026-08-10',
    views: '12.8万',
    tags: ['电影', '盘点', '2026'],
  },
  {
    id: 2,
    title: '极简生活：从断舍离到心灵自由',
    excerpt: '在物质过剩的时代，如何通过极简生活方式找回内心的平静与自由？深度解析极简主义哲学。',
    cover: 'https://readdy.ai/api/search-image?query=Minimalist%20interior%20with%20warm%20natural%20light%2C%20clean%20white%20walls%2C%20wooden%20furniture%2C%20a%20single%20green%20plant%2C%20serene%20atmosphere%2C%20editorial%20photography%2C%20soft%20shadows%2C%20calm%20composition&width=800&height=500&seq=featured-02&orientation=landscape',
    category: '生活方式',
    author: '生活家小林',
    date: '2026-08-09',
    views: '9.6万',
    tags: ['极简', '生活', '心灵'],
  },
  {
    id: 3,
    title: 'AI时代来临：普通人如何抓住机遇',
    excerpt: '人工智能正在改变每个行业，本文为你拆解AI浪潮下的职业机遇与个人发展策略。',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20concept%20with%20abstract%20digital%20networks%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20clean%20modern%20design%2C%20geometric%20patterns%2C%20soft%20glowing%20elements&width=800&height=500&seq=featured-03&orientation=landscape',
    category: '科技数码',
    author: '科技观察员',
    date: '2026-08-08',
    views: '15.3万',
    tags: ['AI', '科技', '职业'],
  },
  {
    id: 4,
    title: '走进故宫：六百年的文化传承',
    excerpt: '故宫不仅是建筑奇迹，更是中华文化的瑰宝。跟随镜头深入探索这座世界文化遗产的独特魅力。',
    cover: 'https://readdy.ai/api/search-image?query=Forbidden%20City%20architecture%20in%20Beijing%20with%20warm%20golden%20hour%20sunlight%2C%20traditional%20Chinese%20rooftops%2C%20red%20walls%2C%20ornate%20details%2C%20artistic%20photography%2C%20cultural%20heritage%20atmosphere&width=800&height=500&seq=featured-04&orientation=landscape',
    category: '文化艺术',
    author: '文化探索者',
    date: '2026-08-07',
    views: '8.2万',
    tags: ['故宫', '文化', '传承'],
  },
];

export const categories = [
  { id: 'entertainment', name: '影视娱乐', icon: 'ri-movie-2-line', count: 2560, color: 'primary' },
  { id: 'lifestyle', name: '生活方式', icon: 'ri-heart-pulse-line', count: 1890, color: 'accent' },
  { id: 'tech', name: '科技数码', icon: 'ri-cpu-line', count: 3210, color: 'secondary' },
  { id: 'culture', name: '文化艺术', icon: 'ri-palette-line', count: 1420, color: 'primary' },
  { id: 'education', name: '知识教育', icon: 'ri-book-open-line', count: 2150, color: 'accent' },
  { id: 'music', name: '音乐之声', icon: 'ri-music-line', count: 980, color: 'secondary' },
];

export const creators = [
  {
    name: '李明远',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20man%20in%20his%2030s%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20friendly%20expression%2C%20modern%20casual%20style&width=200&height=200&seq=creator-01&orientation=squarish',
    title: '影视领域头部创作者',
    followers: '128万',
    works: 342,
    verified: true,
  },
  {
    name: '陈思雨',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20woman%20in%20her%2020s%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20confident%20smile%2C%20creative%20professional%20look&width=200&height=200&seq=creator-02&orientation=squarish',
    title: '生活方式领域达人',
    followers: '96万',
    works: 215,
    verified: true,
  },
  {
    name: '王浩然',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20man%20in%20his%2020s%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20tech%20entrepreneur%20vibe%2C%20modern%20casual&width=200&height=200&seq=creator-03&orientation=squarish',
    title: '科技数码资深作者',
    followers: '85万',
    works: 178,
    verified: true,
  },
  {
    name: '张雅文',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20woman%20in%20her%2030s%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20artistic%20personality%2C%20elegant%20style&width=200&height=200&seq=creator-04&orientation=squarish',
    title: '文化艺术专栏作家',
    followers: '62万',
    works: 156,
    verified: true,
  },
];

export const testimonials = [
  {
    name: '赵先生',
    role: '资深用户',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20man%20in%20his%2040s%2C%20warm%20lighting%2C%20clean%20background%2C%20friendly%20smile&width=120&height=120&seq=testimonial-01&orientation=squarish',
    content: '蜜桃传媒的内容质量真的非常高，每天都会来这里看看有什么新内容。从影视推荐到生活技巧，信息量很大而且都很实用。',
    rating: 5,
  },
  {
    name: '钱女士',
    role: '内容创作者',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20woman%20in%20her%2030s%2C%20warm%20lighting%2C%20clean%20background%2C%20creative%20look&width=120&height=120&seq=testimonial-02&orientation=squarish',
    content: '作为创作者，蜜桃传媒给了我一个非常好的展示平台。这里的读者素质很高，创作氛围也很棒，让我能够专注于创作优质内容。',
    rating: 5,
  },
  {
    name: '孙同学',
    role: '大学生用户',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20young%20man%20in%20his%2020s%2C%20warm%20lighting%2C%20clean%20background%2C%20student%20style&width=120&height=120&seq=testimonial-03&orientation=squarish',
    content: '每天通勤路上都会刷蜜桃传媒的文章，知识教育板块的内容对我的学习帮助很大，已经推荐给了很多同学。',
    rating: 5,
  },
];